




















































































































































































































































































import { Component, Vue, Watch, Ref } from "vue-property-decorator";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import {
  AgendaModel,
  ConfiguracaoPeriodoModel,
} from "@/models/cadastros/saude/AgendaModel";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { tiposEnderecoList } from "@/models/commons/EnderecoModel";
import { CONTA_CORRENTE } from "@/models/commons/TipoContaBancariaModel";
import { tipoServicoVeicularList } from "@/models/commons/TipoServicoModel";
import {
  tiposBancoList,
  TipoBancoModel,
} from "@/models/commons/TipoBancoModel";
import PrestadorAutocomplete from "@/components/saude/PrestadorAutocomplete.vue";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { cadastroAgendaService } from "@/service/cadastro/saude/agenda/CadastroAgendaService";
import { CadastroPrestadorModel } from "@/models/cadastros/saude/CadastroPrestadorModel";
import { EspecialidadePrestadorModel } from "@/models/cadastros/saude/EspecialidadePrestadorModel";
import { ProfissionalModel } from "@/models/cadastros/saude/ProfissionalModel";
import { saudeEspecialidadeService } from "@/service/cadastro/saude/especialidade/SaudeEspecialidadeService";

setInteractionMode("lazy");

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
    GsModalDialog,
    PrestadorAutocomplete,
  },
})
export default class CadastroAgenda extends Vue {
  $refs!: {
    dadosBasicosObserver: InstanceType<typeof ValidationObserver>;
    periodosObserver: InstanceType<typeof ValidationObserver>;
  };

  dialogKey = 0;
  dialog = false;

  cabecalhoAgenda = [
    { text: "Dia da semana", value: "diaSemana", width: "25%" },
    { text: "Horário inicial", value: "horaInicial", width: "25%" },
    { text: "Horário final", value: "horaFinal", width: "25%" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  diasSemana = [
    { text: "Segunda-feira", value: "SEGUNDA" },
    { text: "Terça-feira", value: "TERCA" },
    { text: "Quarta-feira", value: "QUARTA" },
    { text: "Quinta-feira", value: "QUINTA" },
    { text: "Sexta-feira", value: "SEXTA" },
    { text: "Sábado", value: "SABADO" },
    { text: "Domingo", value: "DOMINGO" },
  ];

  agenda: AgendaModel = { configuracaoAgenda: {} };

  periodos: ConfiguracaoPeriodoModel[] = [];
  periodo = {} as ConfiguracaoPeriodoModel;
  prestadorSelecionado = {} as PrestadorResumidoModel;
  prestador = {} as CadastroPrestadorModel;
  listaEspecialidades: EspecialidadePrestadorModel[] = [];
  listaProfissionais: ProfissionalModel[] = [];
  especialidadeSelecionada = {
    especialidade: {},
  } as EspecialidadePrestadorModel;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  periodoIndex = -1;
  isEdit = false;

  textoMensagemExcluirPeriodo = "";
  modalConfirmacao = false;

  obterNomeDiaDaSemana(diaDaSemana: string) {
    return this.diasSemana.find((d) => d.value == diaDaSemana)?.text || "";
  }

  loadInfo() {
    if (this.$route.params.idConfiguracao) {
      this.isEdit = true;
      cadastroAgendaService
        .obterConfiguracaoAgendaPrestador(
          Number(this.$route.params.idConfiguracao)
        )
        .then((res) => {
          this.agenda = res;
          this.periodos = res.configuracaoAgenda?.configuracoesPeriodos || [];
          cadastroPrestadorService
            .obterPrestador(res.idPrestador || 0)
            .then((prestador) => {
              this.prestadorSelecionado = {
                id: res.idPrestador || -1,
                cpfCnpj: prestador.dadosBasicosPrestador.cpfCnpj,
                email: prestador.dadosBasicosPrestador.email,
                tipoPrestador:
                  prestador.dadosBasicosPrestador.tipoPrestador || {},
                nome: prestador.dadosBasicosPrestador.nome,
              };
            });
          saudeEspecialidadeService
            .obterPorId(res.idEspecialidade || -1)
            .then((especialidade) => {
              this.especialidadeSelecionada = {
                especialidade,
              };
            });
        });
    }
  }

  mounted() {
    this.loadInfo();
  }

  adicionarPeriodo() {
    this.$refs.periodosObserver.validate().then((res: boolean) => {
      if (res) {
        const periodo = Object.assign({}, this.periodo);

        if (!this.periodos) {
          this.periodos = [periodo];
        }

        if (this.periodoIndex > -1) {
          this.periodos.splice(this.periodoIndex, 1, periodo);
        } else {
          this.periodos?.push(periodo);
        }
        this.periodo = {} as ConfiguracaoPeriodoModel;
        this.$refs.periodosObserver.reset();
        this.periodoIndex = -1;
      }
    });
  }

  get textoBotaoServico() {
    return this.periodo && this.periodo?.idPeriodo !== undefined
      ? "Salvar período"
      : "Adicionar período";
  }

  alterarPeriodo(periodo: ConfiguracaoPeriodoModel) {
    this.periodoIndex = this.periodos.indexOf(periodo);
    this.periodo = Object.assign({}, periodo);
  }

  confirmacaoRemoverPeriodo(periodo: ConfiguracaoPeriodoModel) {
    this.periodoIndex = this.periodos.indexOf(periodo);
    this.textoMensagemExcluirPeriodo = `Confirma a exlusão do período das ${periodo.horaInicial} às ${periodo.horaFinal} de ${periodo.diaSemana}?`;
    this.modalConfirmacao = true;
  }

  cancelarRemoverPeriodo() {
    this.periodoIndex = -1;
    this.textoMensagemExcluirPeriodo = "";
    this.modalConfirmacao = false;
  }

  removerPeriodo() {
    if (this.periodoIndex > -1) {
      this.periodos.splice(this.periodoIndex, 1);
      this.cancelarRemoverPeriodo();
    }
  }

  cancelarPeriodo() {
    this.periodo = {} as ConfiguracaoPeriodoModel;
    this.$refs.periodosObserver.reset();
    this.periodoIndex = -1;
  }

  acaoDialog(tipo: string) {
    if (tipo == "sucesso") {
      this.$router.push({ name: "ListagemConfiguracaoAgendaPrestador" });
    } else {
      this.openDialog = false;
    }
  }

  @Watch("prestadorSelecionado")
  buscarPrestador() {
    if (this.prestadorSelecionado) {
      cadastroPrestadorService
        .obterPrestador(this.prestadorSelecionado.id)
        .then((prestador: CadastroPrestadorModel) => {
          this.prestador = prestador;
          this.listaEspecialidades = prestador.especialidadesPrestador;
          this.listaProfissionais = prestador.profissionaisPrestador;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.especialidadeSelecionada = {
        especialidade: {},
      } as EspecialidadePrestadorModel;
    }
  }

  gravar() {
    this.$refs.dadosBasicosObserver.validate().then((valid) => {
      if (!this.prestadorSelecionado || !this.prestadorSelecionado.id) {
        valid = false;
        this.$refs.dadosBasicosObserver.setErrors({
          Prestador: "O campo Prestador é obrigatório.",
        });
      }
      if (!this.periodos || this.periodos.length <= 0) {
        valid = false;
        this.$refs.periodosObserver.setErrors({
          "Dia da semana":
            "É necessário adicionar ao menos um período de atendimento",
          "Horário Inicial": " ",
          "Horário final": " ",
        });
      }
      if (valid) {
        if (this.agenda.configuracaoAgenda) {
          this.agenda.configuracaoAgenda.configuracoesPeriodos = this.periodos;
        }

        this.agenda.idEspecialidade = this.especialidadeSelecionada.especialidade?.id;

        this.save();
      } else {
        setTimeout(() => {
          const errors = Object.entries(this.$refs.dadosBasicosObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.dadosBasicosObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    });
  }

  save() {
    this.saveEspecialidade();
  }

  saveEspecialidade() {
    this.agenda.idPrestador = this.prestadorSelecionado.id;

    cadastroAgendaService.salvarAgendaEspecialidade(this.agenda).then(
      (res) => {
        if (this.agenda.id) {
          this.dialogTitle = "Alteração efetivada com sucesso";
          this.dialogMessage = "Agenda alterada com sucesso";
        } else {
          this.dialogTitle = "Cadastro efetivado com sucesso";
          this.dialogMessage = "Cadastro de agenda efetivado com sucesso";
        }
        this.dialogStyle = "success";
        this.dialogType = "sucesso";
        this.openDialog = true;
      },
      (err) => {
        this.dialogTitle = "Erro ao gravar agenda";
        this.dialogMessage = err.message;
        this.dialogStyle = "error";
        this.dialogType = "";
        this.openDialog = true;
      }
    );
  }

  cancelar() {
    this.$router.back();
  }
}
